import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  CardTitle,
  CardSubtitle,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import { AvForm, AvField,  } from "availity-reactstrap-validation";
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import { formatUnitsForReport } from "../../../helpers/units";
import { useRef } from "react";
import moment, { duration } from "moment";
import SweetAlert from "react-bootstrap-sweetalert";

const PlaceOrder = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const refForForm = useRef(null);

  const [selectedEquipment, setSelectedItem] = useState()
  const [remarks, setRemarks] = useState("")
  const [quantity, setQuantity] = useState(0)
  const [rentalDays, setRentalDays] = useState(0);
  const [confirmDurationModal, setConfirmDuartionModal] = useState(false);
  const [is_rented, setIs_Rented] = useState(false);
  const refSelectedItem = useRef(null);


  const handleAddEquipmentForTransfer = async (e, v) => {
    var new_array_items = JSON.parse(JSON.stringify(cartItems));
    const existing_item = new_array_items.filter(function (equip) {
      return equip.equipment_id === selectedEquipment._id;
    });

    if (existing_item.length > 0) {
      showNotification( props.t("This equipment is already added."), props.t("Warning"));
    } else if (selectedEquipment) {
      let equipment_to_add = {};
      equipment_to_add.equipment_id = selectedEquipment?._id;
      equipment_to_add.unit = selectedEquipment.unit;
      equipment_to_add.name = selectedEquipment.name;
      if(rentalDays>0){
        equipment_to_add.is_rented = true;
        equipment_to_add.rental_days = +rentalDays;
      }else{
        equipment_to_add.is_rented = false;
      }
      equipment_to_add.category = selectedEquipment.category;
      equipment_to_add.sub_category = selectedEquipment.sub_category;
      equipment_to_add.brand = selectedEquipment.brand;
      // equipment_to_add.available = selectedEquipment.available_in_unit;
      equipment_to_add.quantity = +quantity;
      // equipment_to_add.cost_price = selectedEquipment.cost_price;
      setCartItems([...cartItems, equipment_to_add]);
      setSelectedItem();
      setIs_Rented(false)
      setQuantity(0)
      setRentalDays(0)
      setConfirmDuartionModal(false)
      refSelectedItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a equipment batch first."), props.t("Error"));
    }
  };

  const handleDeleteRow = (equipment_id) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((equip) => equip.equipment_id !== equipment_id);
      return updatedCartItems;
    });
  };

  const columns_cartitems = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },

    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return   row.quantity+ " " + row.unit
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "is_rented",
      text: props.t("Rented"),
      formatter: (cell, row) => {
        return   row.is_rented ? "Yes" : "No"
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "rental_days",
      text: props.t("Rental Days"),
      formatter: (cell, row) => {
        return   row.is_rented ? row.rental_days : " "
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "",
      text: props.t("Remove"),
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.equipment_id)
              }}
            ></i>
          </span>
        );
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const [isLoading , setIsLoading] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
setIsLoading(true)
      const object = {
        equipment_details: cartItems,
        remarks: remarks,
      };
      let url = process.env.REACT_APP_BASEURL + "equipmentorders/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        setCartItems([]);
        setSelectedItem();
        setRemarks("")
        refSelectedItem.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };
  

  return (
    <React.Fragment>
 
          <Row>

            <Col lg={12}>
              <Card>
                <CardBody >
                <CardTitle>{props.t("Add New Order")}</CardTitle>
                <CardSubtitle>{props.t("Enter the following details to place order for equipments")}</CardSubtitle>
                  <AvForm  onValidSubmit={()=>setIs_Rented(true)} ref={refForForm}>
                    <Row className="mt-2">


                        <Col lg={4} >
                          <Label>{props.t("Equipment")}</Label>
                          <Select
                            ref={refSelectedItem}
                            options={props.equipments}
                            placeholder={props.t("None")}
                            onChange={(se) => { setSelectedItem(se); refForForm.current.reset() }}
                            classNamePrefix="select2-selection"
                            value={selectedEquipment}
                            className="basic-single"

                          />
                        </Col>

                      {selectedEquipment && (
                        <>
                          <Col lg={2}>
                            <Label>{props.t("Equipment Store Avl. Qty.")}</Label>
                            <br />  
  
                            <Label>
                              {selectedEquipment && selectedEquipment?.available_in_unit+ " "+selectedEquipment.unit}
                            </Label>
                          </Col>

                                   

                       <Col lg={3}>
                          <Label>
                            {props.t("Quantity")}{" "}
                            {selectedEquipment
                              ? " (in " + selectedEquipment.unit + ")"
                              : ""}
                          </Label>

                          <AvField
                            name="quantity"
                            placeholder={props.t("Enter Quantity")}
                            errorMessage="Quantity cannot be empty."
                            type="text"
                            onChange={(e)=>setQuantity(e.target.value)}
                            validate={{
                              required: { value: true },
                              pattern: {
                                value: "^[0-9]+$",
                                errorMessage: props.t(
                                  "Only numbers are allowed."
                                ),
                              },
                              max: {
                                value:
                                  selectedEquipment && selectedEquipment.available_in_unit,
                                errorMessage:
                                  selectedEquipment &&
                                  props.t("Cannot order more than ") +
                                    selectedEquipment.available_in_unit +
                                    ".",
                              },
                              min: {
                                value:1,
                                errorMessage:
                                  props.t("Cannot order less than 1  ") +
                                    selectedEquipment.unit +
                                    ".",
                              },
                            }}
                          />
                        </Col>
                          
                        <Col lg={3} className="mb-4">
                                        <Label>&nbsp;</Label>
                                        <br />
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="btn btn-info waves-effect waves-light btn-sm"
                                        >
                                          <i className="bx bx-add-to-queue"></i>{" "}
                                          {props.t("Add")}
                                        </Button>
                        </Col>
                      
                        </>
                       
                      )}

                    </Row>
                 
                  
                  </AvForm>
                  <hr />

                  {cartItems.length > 0 && (
                    <Row className="mt-5">
                      <Col lg={12}>


                        <ToolkitProvider
                          bootstrap4
                          keyField="_id"
                          data={cartItems}
                          columns={columns_cartitems}
                          noDataIndication={props.t("No data to display.")}
                          search
                        >
                          {(props) => (
                            <div>
                              <BootstrapTable
                                striped
                                hover
                                condensed
                                {...props.baseProps}
                              />
                            </div>
                          )}
                        </ToolkitProvider>
                        <AvForm onValidSubmit={handleValidSubmit}>
                          <Row>
                            <Col lg={6}>
                                    <AvField
                                      name="remarks"
                                      value={remarks}
                                      onChange={(e) => {
                                        setRemarks(e.target.value);
                                      }}
                                      label={props.t("Remarks")}
                                      placeholder={props.t("Enter Remarks")}
                                      type="textarea"
                                    />
                                  </Col>
                            <Col lg={12}>
                              <hr />
                              <FormGroup className="mb-0 text-left">
                              <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"140px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Place Order")}
                        </Button>
                      </div>
                              </FormGroup>
                            </Col>
                          </Row>
                        </AvForm>

                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {is_rented && (
                          <SweetAlert
                            title={props.t("Is Equipment Temporary ?")}
                            warning
                            showCancel
                            cancelBtnText={props.t("No")}
                            confirmBtnText={props.t("Yes")}
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            onConfirm={() => {
                              setIs_Rented(false);
                              setConfirmDuartionModal(true);
                            }}
                            onCancel={() => {
                              setIs_Rented(false);
                              handleAddEquipmentForTransfer()
                            }}
                          >
                            {/* {props.t(
                              "Once you reject this order, it cannot be revoked."
                            )} */}
                          </SweetAlert>
                        )}
          <Modal
                    size="md"
                    isOpen={confirmDurationModal}
                    toggle={() => setConfirmDuartionModal(!confirmDurationModal)}
                  >
                    <ModalHeader toggle={() => setConfirmDuartionModal(!confirmDurationModal)}>
                      {props.t("Enter Duartion in days")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddEquipmentForTransfer()
                                }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="duration"
                                      onChange={(e) => {
                                        setRentalDays(e.target.value);
                                      }}
                                      label={props.t("Days")}
                                      placeholder={props.t("Enter days")}
                                      type="number"
                                      validate={{
                                        required: { value: true },
                                      }}
                                      errorMessage="Days cannot be empty."
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Submit")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
    
    </React.Fragment>
  );
};
export default withNamespaces()(PlaceOrder);

